import type * as MT from '../motornet/types';

export const buildVehiclesQuery = (
	params: MT.PlatformVehiclesRequest
): URLSearchParams => {
	const query = new URLSearchParams();

	Object.entries(params).forEach(([key, value]) => {
		if (value === undefined || value === null || value === '') return;

		if (Array.isArray(value)) {
			value.forEach((item) => query.append(key, String(item)));
			return;
		}

		if (typeof value === 'boolean') {
			if (value) query.set(key, 'true');
			return;
		}

		query.set(key, String(value));
	});

	return query;
};
